import useTranslation from '../../hooks/useTranslation';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SignatureSection: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.signatureSection} testId={testId}>
            <Wrapper className={styles.sectionHeader}>{translations.SIGNATURE}</Wrapper>

            <Wrapper className={styles.signatureLine}>{translations.SIGNED_BY}</Wrapper>

            <Wrapper className={styles.signatureLine}>{translations.SIGNATURE_DATE}</Wrapper>
        </VerticalContainer>
    );
};

export default SignatureSection;
